/* Lynexas — bulk quick add: stepper [- n +] duoi moi card o trang collection.
   "+" muon nguyen form quick-add native cua Horizon (product-form-component xu ly
   add + cart drawer + icon). "-" goi /cart/update.js roi phat CartLinesUpdateEvent
   dung hop dong ma cart-drawer/cart-icon/component-cart-items dang nghe. */
import { CartLinesUpdateEvent } from '@shopify/events';

(() => {
  if (window.__lyxBulkAdd) return;
  window.__lyxBulkAdd = true;

  let counts = new Map(); // variantId (string) -> qty trong gio
  let refreshTimer = null;

  async function refreshCounts() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      counts = new Map(cart.items.map((i) => [String(i.variant_id), i.quantity]));
      applyCounts();
    } catch (e) {
      /* mang loi: giu so cu */
    }
  }

  function applyCounts() {
    document.querySelectorAll('.lyx-qty').forEach((el) => {
      const q = counts.get(el.dataset.lyxVariant) || 0;
      const countEl = el.querySelector('[data-lyx-count]');
      const minusBtn = el.querySelector('[data-lyx-minus]');
      if (countEl) countEl.textContent = q;
      if (minusBtn) minusBtn.disabled = q === 0;
    });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCounts, 150);
  }

  function cartItemsSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
  }

  function increase(wrap) {
    const host = wrap.parentElement;
    const form = host && host.querySelector('.lyx-native-qa form[data-type="add-to-cart-form"]');
    if (form) {
      form.requestSubmit();
      return;
    }
    // Khong tim thay form native (san pham nhieu variant chang han) -> ve trang san pham
    const card = wrap.closest('[data-product-url]');
    if (card) window.location.href = card.dataset.productUrl;
  }

  async function decrease(wrap) {
    const vid = wrap.dataset.lyxVariant;
    const current = counts.get(vid) || 0;
    if (current === 0) return;
    const target = current - 1;

    const sectionIds = cartItemsSectionIds();
    const body = { updates: { [vid]: target } };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    // Dung DUNG helper cua Shopify de cart drawer / cart icon nhan dung du lieu
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'update',
        context: 'product',
        lines: [{ merchandiseId: vid, quantity: target }],
        promise: deferred.promise,
      })
    );

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const ajaxCart = await res.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          itemCount: ajaxCart.item_count,
          sections: ajaxCart.sections,
          source: 'lynexas-bulk-add',
          didError: false,
        },
      });
      counts.set(vid, target);
      applyCounts();
    } catch (e) {
      deferred.reject(e);
    }
    scheduleRefresh();
  }

  document.addEventListener('click', (e) => {
    const plus = e.target.closest('[data-lyx-plus]');
    const minus = e.target.closest('[data-lyx-minus]');
    if (!plus && !minus) return;
    const wrap = (plus || minus).closest('.lyx-qty');
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();
    if (plus) increase(wrap);
    else decrease(wrap);
  });

  // Moi thay doi gio hang (ke ca tu quick-add native cua "+", cart drawer, trang cart)
  // -> dong bo lai so tren cac stepper
  document.addEventListener('shopify:cart:lines-update', (e) => {
    if (e.promise && typeof e.promise.then === 'function') {
      e.promise.then(scheduleRefresh).catch(() => {});
    } else {
      scheduleRefresh();
    }
  });

  // Filter / infinite scroll thay the luoi san pham -> cards moi can so
  document.addEventListener('shopify:collection:update', scheduleRefresh);

  refreshCounts();
})();
